// src/App.tsx
import React, { useEffect } from "react";
import { HashRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./contexts/AuthContext";
import { getSocket } from "./pages/websocket/socket";


export default function App() {
  useEffect(() => {
    // Initialize socket on app start
    const socket = getSocket();

    // Example: Listen for global events
    socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
    socket.on("disconnect", (reason) =>
      console.log("⚡ Socket disconnected:", reason)
    );

    return () => {
      // Clean up all listeners on unmount
      socket.off("connect");
      socket.off("disconnect");
    };
  }, []);

  return (
    <React.StrictMode>
      <HashRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </HashRouter>
    </React.StrictMode>
  );
}
